import { IAttachment } from '@app/models/Attachment'

export function filterAttachments(
  filterText: string,
): (attachment?: IAttachment) => boolean {
  const lowerFilterText = filterText.toLowerCase()

  return (attachment?: IAttachment): boolean => {
    return (
      attachment !== undefined &&
      attachment.title.toLowerCase().indexOf(lowerFilterText) > -1
    )
  }
}
